import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import {
  ORDERABLE_ITEM_BY_ACCOUNT_ID,
  BTF_PRODUCT_PACKAGE,
  EVALUATION_PRODUCTS,
  CURRENT_PRODUCT_PACKAGE,
  PRODUCT_PACKAGES_BY_KEYS,
  PRODUCT_PACKAGE,
  PRODUCT_OFFERING_KEY_MAPPING,
} from './types';
import {
  orderableItemByAccountId,
  getBTFProductAvailableForEvaluation,
  getCurrentProductPackage,
  getEvaluationProducts,
  getProductPackageById,
  getProductPackagesByKeys,
  getProductOfferingKeyMappings,
} from '../../api';

export const fetchOrderableItemByAccountId =
  (accountId: number) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    const getCustomerByEmailData = orderableItemByAccountId(accountId, state);
    dispatch(thunkProgress(ORDERABLE_ITEM_BY_ACCOUNT_ID, getCustomerByEmailData, { accountId }));
  };

export const fetchProductPackagesByKeys =
  (keys: string[]) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(thunkProgress(PRODUCT_PACKAGES_BY_KEYS, getProductPackagesByKeys(keys, getState())));
  };

export const fetchEvaluationProducts = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(EVALUATION_PRODUCTS, getEvaluationProducts(getState())));
};

export const fetchCurrentProductPackage =
  (productKey: string) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(CURRENT_PRODUCT_PACKAGE, getCurrentProductPackage(productKey, getState()), {
        productKey,
      }),
    );
  };

export const fetchBTFProductAvailableForEvaluation =
  (addOnKey: string) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(
        BTF_PRODUCT_PACKAGE,
        getBTFProductAvailableForEvaluation(addOnKey, getState()),
        {
          addOnKey,
        },
      ),
    );
  };

export const fetchProductPackage =
  (productPackageId: number) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(PRODUCT_PACKAGE, getProductPackageById(productPackageId, getState()), {
        productPackageId,
      }),
    );
  };

export const fetchProductOfferingKeyMappings = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch(thunkProgress(PRODUCT_OFFERING_KEY_MAPPING, getProductOfferingKeyMappings(getState())));
};
